/**
*
* Fade
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { createGlobalStyle } from 'styled-components';


// eslint-disable-next-line no-unused-expressions
createGlobalStyle`
  .loading-animation-enter,
  .loading-animation-appear {
    opacity: 0.01;
  }

  .loading-animation-enter.loading-animation-enter-active,
  .loading-animation-appear.loading-animation-appear-active {
    opacity: 1;
    transition: opacity 500ms ease-in;
  }

  .loading-animation-exit {
    opacity: 1;
  }

  .loading-animation-exit.loading-animation-exit-active {
    opacity: 0.01;
    transition: opacity 300ms ease-in;
  }
`;

function Fade({ inProps, children }) {
  return (
      children && <CSSTransition
        in={inProps}
        timeout={{ enter: 500, exit: 300 }}
        classNames={'loading-animation'}
      >
        {
        children
       }
      </CSSTransition>
  );
}

Fade.propTypes = {
  inProps: PropTypes.bool,
  children: PropTypes.node,
};

Fade.defaultProps = {
  children: null,
  inProps: false,
};

export default Fade;
